import React from 'react';

import InputMask from 'react-input-mask';

import { cn } from '../../common/utilities';

export interface TextInputProps extends Omit<React.ComponentProps<'label'>, 'onChange'> {
  label: string;
  value?: React.ComponentProps<'input'>['value'];
  onChange?: React.ComponentProps<'input'>['onChange'];
  autoComplete?: React.ComponentProps<'input'>['autoComplete'];
  inputProps?: React.ComponentProps<'input'>;
  error?: string | null;
  mask?: string;
  maskChar?: string | null;
}

export function TextInput(props: TextInputProps) {
  const { label, className, value, onChange, inputProps, error, mask, autoComplete, maskChar, ...rest } = props;
  const Input = mask ? InputMask : 'input';

  return (
    <label {...rest} className={cn('TextInput', 'flex flex-col max-w-xs group text-grey-900 text-base', className)}>
      <span className="group-focus-within:text-blue-800">{label}</span>
      <Input
        {...inputProps}
        autoComplete={autoComplete}
        mask={mask ?? ''}
        maskChar={maskChar}
        type="text"
        className={cn(
          'border border-solid border-grey-400 px-4 py-3 focus-within:border-blue-800 text-base',
          inputProps?.className
        )}
      />
      {error && <span className="text-red-500 text-sm pt-[2px]">{error}</span>}
    </label>
  );
}
